<form class="form-step-3">
    <div class="row" style="overflow-y: auto">
        <div class="col-12">
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
                    <mat-panel-title class="mat-panel-title" style="margin-top: 20px;">
                        {{ "add_document_moha.declare_employment_contract_data" | translate }}
                    </mat-panel-title>
                    <div class="row mt-2">
                        <div class="col-4" style="margin-left: 16px;">
                            <mat-form-field class="w-100">
                                <input matInput
                                    id="customer"
                                    name="customer"
                                    [placeholder]="'add_document_moha.employee' | translate"
                                    [value]="customerName || getCustomerName(customerControl.value)"
                                    readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- TiÃªu chÃ­ thay Ä‘á»•i thÃ´ng tin  -->
                    <mat-expansion-panel expanded="true" class="mat-elevation-z0 criteria-panel" *ngIf="isPlContract">
                        <mat-expansion-panel-header>
                            <mat-panel-description class="mat-panel-title">
                                {{ titleChange }} &nbsp;
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="criteria-table-wrapper">
                            <mat-table [dataSource]="listDataChangeSource" class="criteria-table">
                                <!-- STT -->
                                <ng-container matColumnDef="stt">
                                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                        {{ "headertable.stt" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index" class="mat-cell-non-boder-right-bottom">
                                        {{ element.stt }}
                                    </mat-cell>
                                </ng-container>
                                <!-- TÃªn tiÃªu chÃ­ -->
                                <ng-container matColumnDef="nameCriteria">
                                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                        {{ "labor_utilization_report.criterion_name" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index"
                                        class="mat-cell-non-boder-right-bottom cell">
                                        <span class="fix-width fw-100 nameDoc">
                                            {{ element.name }} <span *ngIf="element.isRequired" style="color: red">&nbsp;*</span>
                                        </span>
                                    </mat-cell>
                                </ng-container>
                                <!-- TrÆ°á»ng thÃ´ng tin cá»§a máº«u -->
                                <ng-container matColumnDef="infoTemplate">
                                    <mat-header-cell *matHeaderCellDef class="text-center mat-cell-non-boder-right-bottom">
                                        {{ "labor_utilization_report.template_information_fields" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index" class="mat-cell-non-boder-right-bottom">

                                        <ng-container
                                            [ngTemplateOutlet]="criterionControl"
                                            [ngTemplateOutletContext]="{ $implicit: element, change: true }">
                                        </ng-container>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
                                </mat-row>
                            </mat-table>
                        </div>
                    </mat-expansion-panel>

                    <!-- Danh sÃ¡ch thÃ´ng tin bÃ¡o cÃ¡o HDLD  -->
                    <mat-expansion-panel expanded="true" class="mat-elevation-z0 criteria-panel" style="margin-top: 30px; margin-bottom: 25px;">
                        <mat-expansion-panel-header>
                            <mat-panel-description class="mat-panel-title">
                              {{ "add_document_moha.employment_contract_data" | translate }} &nbsp;
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <div class="criteria-table-wrapper">
                            <mat-table [dataSource]="listDataTable" [trackBy]="trackByCode" class="criteria-table">
                                <ng-container matColumnDef="groupHeader">
                                    <mat-cell *matCellDef="let element" class="group-header-cell">
                                        <button mat-icon-button type="button" class="toggle-button"
                                            (click)="toggleGroup(element)">
                                            <ng-container *ngIf="!element.expanded">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 8H10M8 6V10M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333Z" stroke="#6F767E" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </ng-container>
                                            <ng-container *ngIf="element.expanded">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.33333 8H10.6667M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V5.2C14 4.0799 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </ng-container>
                                        </button>
                                        <strong>{{ element.name }}</strong>
                                    </mat-cell>
                                </ng-container>
                                <!-- STT -->
                                <ng-container matColumnDef="stt">
                                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                        {{ "headertable.stt" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index" class="mat-cell-non-boder-right-bottom">
                                        <button *ngIf="element.rowType === 'subheader'"
                                            mat-icon-button type="button" class="toggle-button"
                                            (click)="toggleGroup(element)">
                                            <mat-icon>{{ element.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                                        </button>
                                        <span *ngIf="!element.level || element.level <= 1">
                                            {{ element.displayOrder }}
                                        </span>
                                    </mat-cell>
                                </ng-container>
                                <!-- TÃªn tiÃªu chÃ­ -->
                                <ng-container matColumnDef="nameCriteria">
                                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                        {{ "add_document_moha.criteria_name" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index"
                                        [matTooltip]="element.name"
                                        [class.subheader-name]="element.rowType === 'subheader'"
                                        class="mat-cell-non-boder-right-bottom cell">
                                        <span class="fix-width fw-100 nameDoc">
                                            <span *ngIf="element.level > 1" class="child-display-order">
                                                {{ element.displayOrder }}
                                            </span>
                                            {{ element.name }} <span *ngIf="element.isRequired" style="color: red">&nbsp;*</span>
                                        </span>
                                    </mat-cell>
                                </ng-container>
                                <!-- TrÆ°á»ng thÃ´ng tin cá»§a máº«u -->
                                <ng-container matColumnDef="infoTemplate">
                                    <mat-header-cell *matHeaderCellDef class="text-center mat-cell-non-boder-right-bottom">
                                        {{ "handsontable.title.value" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let i = index" class="mat-cell-non-boder-right-bottom">

                                        <ng-container *ngIf="element.rowType === 'criterion'"
                                            [ngTemplateOutlet]="criterionControl"
                                            [ngTemplateOutletContext]="{ $implicit: element, change: false }">
                                        </ng-container>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: headerColumns; when: isHeaderRow"
                                    [class.row-hidden]="!isRowVisible(row)" class="group-header-row">
                                </mat-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns; when: isCriterionRow"
                                    [class.subheader-row]="row.rowType === 'subheader'"
                                    [class.row-hidden]="!isRowVisible(row)" class="criterion-row">
                                </mat-row>
                            </mat-table>
                          </div>
                    </mat-expansion-panel>

                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

    <ng-template #criterionControl let-element let-change="change">
        <div class="criterion-control" [ngSwitch]="element.inputType">
            <div *ngSwitchCase="'TEXT'" class="control-with-error">
                <nz-input-group class="report-input-group" [nzSuffix]="inputClearTpl">
                    <input
                        nz-input
                        type="text"
                        autocomplete="off"
                        [maxlength]="element.maxLength || 255"
                        [placeholder]="'add_document_moha.enter_information_field' | translate"
                        [formControl]="element.controlField"
                        [disabled]="!change && isPlContract"
                        [class.required-field]="element.isRequired"
                        (focusout)="focusOutInput(element)" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                    <i
                        *ngIf="element.controlField?.value && (change || !isPlContract) && !element.controlField?.disabled"
                        nz-icon
                        nzType="close-circle"
                        nzTheme="fill"
                        class="input-clear-icon"
                        (click)="clearDataPropertie(element, change ? 'CHANGE' : null)">
                    </i>
                </ng-template>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.required" class="control-error">
                    {{ element.requiredMessage || ('add_document_moha.required_field' | translate : ({field: element.name})) }}
                </div>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.pattern" class="control-error">
                    {{ element.regexMessage ? element.regexMessage : ('add_document_moha.wrong_format' | translate : ({field: element.name})) }}
                </div>
            </div>

            <div *ngSwitchCase="'DROPDOWN'" class="control-with-error">
                <nz-select
                    class="merge-field-select"
                    nzShowSearch
                    nzAllowClear
                    [class.required-field]="element.isRequired"
                    [nzDisabled]="!change && isPlContract"
                    [nzPlaceHolder]="'add_document_moha.select_information_field' | translate"
                    [formControl]="element.controlField">
                    <nz-option
                        *ngFor="let data of optionsMap.get(element.code)"
                        [nzValue]="data.value"
                        [nzLabel]="data.name">
                    </nz-option>
                </nz-select>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.required" class="control-error">
                    {{ element.requiredMessage || ('add_document_moha.required_field' | translate : ({field: element.name})) }}
                </div>
            </div>

            <div *ngSwitchCase="'DATETIME'" class="control-with-error">
                <nz-date-picker
                    class="report-control"
                    nzAllowClear
                    nzFormat="dd/MM/yyyy"
                    [class.required-field]="element.isRequired"
                    [nzDisabled]="!change && isPlContract"
                    [nzDisabledDate]="getDisabledDateForField(element)"
                    [nzPlaceHolder]="'add_document_moha.select_information_field' | translate"
                    (nzOnOpenChange)="onDatePickerOpenChange($event, element)"
                    [formControl]="element.controlField">
                </nz-date-picker>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.required && !element.controlField?.errors?.invalidDateFormat" class="control-error">
                    {{ element.requiredMessage || ('add_document_moha.required_field' | translate : ({field: element.name})) }}
                </div>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.invalidDateFormat" class="control-error">
                    Ngày không đúng định dạng dd/MM/yyyy
                </div>
                <div *ngIf="element.controlField?.errors?.hazardousDateOrder && isDateRangeTouched('nndh_ket_thuc')" class="control-error">
                    Ngày tham gia làm nghề phải nhỏ hơn ngày kết thúc làm nghề
                </div>
                <div *ngIf="element.controlField?.errors?.contractDateOrder && isDateRangeTouched('ngay_ket_thuc_hdld')" class="control-error">
                    Thời điểm kết thúc HĐLĐ phải lớn hơn hoặc bằng Thời điểm thực hiện HĐLĐ
                </div>
                <div *ngIf="element.controlField?.touched && element.controlField?.errors?.contractStartNotAfterBirthDate" class="control-error">
                    Thời điểm bắt đầu HĐLĐ phải lớn hơn ngày sinh của NLĐ
                </div>
            </div>
        </div>
    </ng-template>

    <button type="submit" #panelSubmit style="display: none;"></button>
</form>
